import React, { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Stack } from '@mui/material'

import { useStores, ISelectorOption } from '@trivie/core'
import { Dialog } from '@trivie/ui-web/components/dialogs/dialog'
import { Text } from '@trivie/ui-web/components/text'
import { BadgeAvatar } from '@trivie/ui-web/components/badge-avatar'
import { AutocompleteSelector } from '../../../components/autocomplete-selector'

export const AwardBadgeDialog = observer(
  (props: { onConfirm?: any; open: boolean; requestClose: () => void; badge: any | null }) => {
    const { badgesStore } = useStores()
    const { onConfirm, open, badge } = props
    const { awardBadge } = badgesStore

    const [selectedOptions, setSelectedOptions] = useState<ISelectorOption[]>([])

    const onClickAdd = () => {
      if (badge?.id) {
        const data = {
          badge_id: badge.id,
          group_ids: selectedOptions.filter((f) => f.type === 'Groups').map((gr) => gr.id),
          user_ids: selectedOptions.filter((f) => f.type === 'Users').map((usr) => usr.id),
        }
        awardBadge(data).then(() => {
          onConfirm()
        })
      }
    }

    const handleSelectionChange = (selected: ISelectorOption[]) => {
      setSelectedOptions(selected)
    }

    return (
      <Dialog
        disableConfirm={selectedOptions?.length === 0}
        confirmBtnLabel="Award"
        onConfirm={onClickAdd}
        onCancel={props.requestClose}
        onClose={props.requestClose}
        title="Award Badge"
        open={open}
        maxWidth="md"
        sx={{
          '& .MuiDialogContent-root': {
            display: 'flex',
            flexDirection: 'column',
          },
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            overflowY: 'hidden',
            transition: 'all 0.5s ease-in-out',
            height: 500,
          }}
        >
          <Stack mb={2} useFlexGap gap={2} direction="row">
            <BadgeAvatar
              size={40}
              name={badge?.badge_title}
              url={badge?.photo_url}
              hoverable={false}
            />
            <Stack>
              <Text variant="body1Emphasized" text={badge?.badge_title ?? ''} />
              <Text
                variant="body2Medium"
                color="text.secondary"
                text={badge?.badge_criteria ?? ''}
              />
            </Stack>
          </Stack>
          <AutocompleteSelector
            variant="users-groups"
            open
            onSelectionChange={handleSelectionChange}
            style={{ flex: 1, display: 'flex', flexDirection: 'column' }}
          />
        </div>
      </Dialog>
    )
  },
)
